interface MarkProps {
  size?: number;
  /** Animates the overlap drawing itself in. Ignored under reduced motion. */
  animated?: boolean;
  className?: string;
}

/**
 * The brand mark: two circles that overlap.
 *
 * It is the whole product in one shape — two separate people, and the part in
 * the middle that is shared. It is deliberately not a heart, not a flame and
 * not a pair of speech bubbles.
 */
export function Mark({ size = 32, animated = false, className }: MarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <circle
        cx="19"
        cy="24"
        r="11.5"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.55"
        style={
          animated
            ? {
                strokeDasharray: 73,
                animation: 'awc-draw var(--dur-slower) var(--ease-out) both',
              }
            : undefined
        }
      />
      <circle
        cx="29"
        cy="24"
        r="11.5"
        stroke="var(--accent)"
        strokeWidth="2"
        style={
          animated
            ? {
                strokeDasharray: 73,
                animation: 'awc-draw var(--dur-slower) var(--ease-out) 120ms both',
              }
            : undefined
        }
      />
      {/* The overlap itself: the lens where the two circles meet. */}
      <path
        d="M24 13.6a11.5 11.5 0 0 0 0 20.8 11.5 11.5 0 0 0 0-20.8Z"
        fill="var(--accent)"
        opacity="0.22"
        style={
          animated
            ? { animation: 'awc-fade var(--dur-slow) var(--ease-out) 420ms both' }
            : undefined
        }
      />
    </svg>
  );
}
